import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CityClinicNavbar from './components/Navbar';
import Footer from './components/Footer';
import Banner from './pages/Banner';
import AboutDoctor from './pages/AboutDoctor';
import BestUrologistSection from './pages/BestUrologistSection';
import CancerTreatmentSection from './pages/CancerTreatmentSection';
import ContactStepsSection from './pages/ContactStepsSection';
import HappyCustomersSection from './pages/HappyCustomersSection';
import GallerySection from './pages/GallerySection';
import Facility from './pages/Facility';
import Gallery from './pages/Gallery';
import ContactPage from './pages/ContactPage';
import Blog from './pages/Blog';
import Urological from './pages/Urological';
import FAQ from './pages/FAQ';
import FloatingContactIcon from './components/FloatingContactIcons';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
        <CityClinicNavbar />
        <FloatingContactIcon/>
        
        <Routes>
          <Route path="/" element={
            <main>
              <Banner/>
              <BestUrologistSection />
              <Urological/>
              <CancerTreatmentSection />
              <ContactStepsSection />
              <HappyCustomersSection />
              <FAQ/>
              <GallerySection />
            </main>
          } />
          
          <Route path="/about-doctor" element={<AboutDoctor/>}/>
          <Route path='/facility' element={<Facility/>}/>
          <Route path='/blog' element={<Blog/>}/>
          <Route path='/gallery'element={<Gallery/>}/>
          <Route path='/contact'element={<ContactPage/>}/>
        </Routes>        
        <Footer />
      </div>
    </Router>
  );
}

export default App;